import React from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";

interface GaraazAlertDialogue {
  onOpen: () => void;
  onClose: () => void;
  isOpen: boolean;
  leftBtnText?: string;
  submitBtnText?: string;
  onSubmitBtn: () => void;
  alertBodyText: any;
  alertDialogueHeaderText: string;
  submitBtnColorScheme?: string;
  cancelBtnColorScheme?: string;
  isSubmitBtnDisabled?: boolean;
  isCentered?: boolean;
  isSubmitBtnLoading?: boolean;
  /** When true, hide the left/cancel button (used for Hard ETA alerts). */
  hideCancelButton?: boolean;
  closeOnEsc?: boolean;
  closeOnOverlayClick?: boolean;
  size?:
    | "xs"
    | "sm"
    | "md"
    | "lg"
    | "xl"
    | "2xl"
    | "3xl"
    | "4xl"
    | "5xl"
    | "6xl"
    | "full";
}

function GaraazAlertDialogue(props: GaraazAlertDialogue) {
  const cancelRef = React.useRef(null);
  const hideCancel = Boolean(props.hideCancelButton);

  return (
    <AlertDialog
      leastDestructiveRef={cancelRef}
      isOpen={props.isOpen}
      onClose={props.onClose}
      returnFocusOnClose={false}
      isCentered={props.isCentered}
      size={props.size}
      closeOnEsc={props.closeOnEsc ?? true}
      closeOnOverlayClick={props.closeOnOverlayClick ?? true}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {props.alertDialogueHeaderText}
          </AlertDialogHeader>
          <AlertDialogBody>{props.alertBodyText}</AlertDialogBody>
          <AlertDialogFooter>
            {!hideCancel && (
              <Button
                bg={props.cancelBtnColorScheme || "gray.100"}
                ref={cancelRef}
                onClick={props.onClose}
              >
                {props.leftBtnText || "Cancel"}
              </Button>
            )}
            <Button
              colorScheme={props.submitBtnColorScheme || "blue"}
              bg={props.submitBtnColorScheme || "blue.500"}
              onClick={props.onSubmitBtn}
              ml={hideCancel ? 0 : 3}
              isDisabled={props.isSubmitBtnDisabled || props.isSubmitBtnLoading}
              isLoading={props.isSubmitBtnLoading}
              ref={hideCancel ? cancelRef : undefined}
            >
              {props.submitBtnText || "Save"}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}

export default GaraazAlertDialogue;
